import intl from "react-intl-universal";
import type { AppState } from "@stores/AppState";
import { CrudServices } from "../../platform/services/types/ServiceDependencies";
import { queryGqlApi } from "../../graphql/queryGqlApi";
import { deleteRole as deleteRoleGQL } from "../../graphql/rbac/mutations";

export const deleteRole = async (
    services: CrudServices,
    appState: AppState,
    roleId: string,
    roleName: string
) => {
    // Show confirmation dialog
    const confirmed = confirm(
        intl.get('roleDelete.confirm.message')
            .d(`Are you sure you want to delete the role "${roleName}"? This will remove all access grants for assigned users. This action cannot be undone.`)
            .replace('{name}', roleName)
    );

    if (!confirmed) {
        return;
    }

    try {
        await queryGqlApi(
            deleteRoleGQL,
            { input: { id: roleId } },
            services.dataClientService,
            services.authService,
            'pgServer'
        );

        // Show success message (if you have a toast system)
        console.log(intl.get('roleDelete.success').d('Role deleted successfully'));
    } catch (error) {
        console.error('Error deleting role:', error);
        alert(intl.get('roleDelete.error').d('Failed to delete role. Please try again.'));
    }
};
